<template>
  <div class="xcard">
    <h3 class="text-center mt-0">{{ title }}</h3>
    <button :disabled="$store.state.isonlyread" v-show="datosbyunidad.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')">
      <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
    </button>
    <div class="table-responsive" v-if="typeasign == 1">
      <table class="xtable table-condensed" ref="table">
        <thead class="text-center green darken-4 white--text">
          <tr class="white--text">
            <th class="fixedheader" style="width:25px;max-width:25px;min-width:25px">#</th>
            <th style="background:#196391">Sede</th>
            <th>Total</th>
            <th>Saldo</th>
            <th>Deuda</th>
            <th>Importe</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, ind) in datosbyunidad" :key="ind">
            <td>{{ ind + 1 }}</td>
            <td>{{ d.sede_nombre }}</td>
            <td class="text-right">{{ parsecomas(d.total) }}</td>
            <td class="text-right">{{ parsecomas(d.saldo) }}</td>
            <td class="text-right">{{ parsecomas(d.deuda) }}</td>
            <td class="text-right">{{ parsecomas(d.importe) }}</td>
          </tr>
          <tr class="text-right green darken-4 white--text">
            <td colspan="2" class="text-center" style="background:#196391;color:white">TOTAL</td>
            <td style="color:white!important">{{ parsecomas(xtotales.total) }}</td>
            <td>{{ parsecomas(xtotales.saldo) }}</td>
            <td>{{ parsecomas(xtotales.deuda) }}</td>
            <td>{{ parsecomas(xtotales.importe) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-responsive" v-else-if="typeasign == 2">
      <table class="xtable table-condensed">
        <thead class="text-center green darken-4 white--text">
          <tr class="white--text">
            <th class="fixedheader" style="width:25px;max-width:25px;min-width:25px">#</th>
            <th style="background:#196391">Programa</th>
            <th>Total</th>
            <th>Saldo</th>
            <th>Deuda</th>
            <th>Importe</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, ind) in datosbysede" :key="ind">
            <td>{{ ind + 1 }}</td>
            <td>{{ d.programa_nombre }}</td>
            <td class="text-right">{{ parsecomas(d.total) }}</td>
            <td class="text-right">{{ parsecomas(d.saldo) }}</td>
            <td class="text-right">{{ parsecomas(d.deuda) }}</td>
            <td class="text-right">{{ parsecomas(d.importe) }}</td>
          </tr>
          <tr class="text-right green darken-4 white--text">
            <td colspan="2" class="text-center" style="background:#196391;color:white">TOTAL</td>
            <td style="color:white!important">{{ parsecomas(xtotales.total) }}</td>
            <td>{{ parsecomas(xtotales.saldo) }}</td>
            <td>{{ parsecomas(xtotales.deuda) }}</td>
            <td>{{ parsecomas(xtotales.importe) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--  -->
    <div class="table-responsive" v-else-if="typeasign == 3">
      <table class="xtable table-condensed">
        <thead class="text-center green darken-4 white--text">
          <tr class="white--text">
            <th class="fixedheader" style="width:25px;max-width:25px;min-width:25px">#</th>
            <th style="background:#196391">Estudiante</th>
            <th>Total</th>
            <th>Saldo</th>
            <th>Deuda</th>
            <th>Importe</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, ind) in datosbyprograma" :key="ind">
            <td>{{ ind + 1 }}</td>
            <td>{{ d.nombres }} {{ d.apellido_paterno }} {{ d.apellido_materno }}</td>
            <td class="text-right">{{ parsecomas(d.total) }}</td>
            <td class="text-right">{{ parsecomas(d.saldo) }}</td>
            <td class="text-right">{{ parsecomas(d.deuda) }}</td>
            <td class="text-right">{{ parsecomas(d.importe) }}</td>
          </tr>
          <tr class="text-right green darken-4 white--text">
            <td colspan="2" class="text-center" style="background:#196391;color:white">TOTAL</td>
            <td style="color:white!important">{{ parsecomas(xtotales.total) }}</td>
            <td>{{ parsecomas(xtotales.saldo) }}</td>
            <td>{{ parsecomas(xtotales.deuda) }}</td>
            <td>{{ parsecomas(xtotales.importe) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
  </div>
</template>

<style></style>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
            return c[p];
          });
        },
        // END EXCEL
        sedes: [],
        totales: [],
        title: '',
        typeasign: 0,
        datosbysede: [],
        datosbyprograma: [],
        datosbyunidad: [],
        xtotales: {
          deuda: 0,
          saldo: 0,
          total: 0,
          importe: 0,
        },
      };
    },
    watch: {},
    components: {},
    methods: {
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_CERTIFICACIONES.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      resetasignaciones() {
        this.totales = [];
        this.datosbysede = [];
        this.datosbyprograma = [];
        this.xtotales.deuda = 0;
        this.xtotales.saldo = 0;
        this.xtotales.total = 0;
        this.xtotales.importe = 0;
      },
      obtenerasignaciones(mes, anio, unidadid, sede, programa) {
        const vue = this;
        this.resetasignaciones();
        let urla = `${process.env.VUE_APP_API_REST}/api/v1/asignacion/unidad_negocio?month=${mes}&year=${anio}&unidad_negocio_id=${unidadid}`;
        if (programa) {
          vue.typeasign = 3;
          vue.title = 'Reporte certificacion por programa';
          urla = `${process.env.VUE_APP_API_REST}/api/v1/reporte-certificacion/programa?month=${mes}&year=${anio}&programa_id=${programa.id}`;
        } else if (sede) {
          vue.typeasign = 2;
          vue.title = 'Reporte certificacion por sede: ' + sede.nombre;
          urla = `${process.env.VUE_APP_API_REST}/api/v1/reporte-certificacion/sede?month=${mes}&year=${anio}&sede_id=${sede.id}`;
        } else {
          vue.typeasign = 1;
          vue.title = 'Reporte certificacion por unidad de negocio';
          urla = `${process.env.VUE_APP_API_REST}/api/v1/reporte-certificacion/unidad_negocio?month=${mes}&year=${anio}&unidad_negocio_id=${unidadid}`;
        }
        window.console.log(urla);

        const promise1 = xaxios.get(urla);
        Promise.all([promise1])
          .then(function(values) {
            if (!values[0] || !values[0].data) values[0] = { data: { data: [] } };
            let data1 = values[0].data.data;

            if (vue.typeasign == 2) {
              data1.forEach((x) => {
                vue.xtotales.deuda += x.deuda;
                vue.xtotales.saldo += x.saldo;
                vue.xtotales.total += x.total;
                vue.xtotales.importe += x.importe;
              });
              vue.datosbysede = data1;
            } else if (vue.typeasign == 3) {
              data1.forEach((x) => {
                vue.xtotales.deuda += x.deuda;
                vue.xtotales.saldo += x.saldo;
                vue.xtotales.total += x.total;
                vue.xtotales.importe += x.importe;
              });
              vue.datosbyprograma = data1;
            } else if (vue.typeasign == 1) {
              data1.forEach((x) => {
                vue.xtotales.deuda += x.deuda;
                vue.xtotales.saldo += x.saldo;
                vue.xtotales.total += x.total;
                vue.xtotales.importe += x.importe;
              });
              vue.datosbyunidad = data1;
            }

            vue.$emit('dataloaded');
          })
          .catch((e) => {
            try {
              window.console.error(e.response.data);
            } catch (e) {
              window.console.error(e);
            }
            window.console.error(e);
            vue.$emit('dataloaded');
          });
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
    },
    mounted() {},
  };
  ('');
</script>
